const institucionEstablecimientoRouter = [
  {
    path: "/solicitud-eliminacion-empleados",
    name: "solicitud-eliminacion-empleados",
    component: () => import(/* webpackChunkName: "renuncias" */ "./index.vue"),
  },
];

export default institucionEstablecimientoRouter;